import axios from "axios";
import { CacheModule } from "@/utils/commonUtils.js";
import stored from "../store/index";
import router from '../router/index'
import { store, mutations } from "@/observable/store";
import { Dialog } from "vant";
import GLO from "../utils/global"


const service = axios.create({
  // baseURL: 'https://mceshi.xzjy365.com/', // url = base url + request url
  // baseURL: 'http://192.168.1.58:6060/',
  baseURL:GLO.apiUrl,
  // baseURL: 'https://m.xzjy365.com',
  // baseURL: `${window.location.origin}/`, 
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout;
  crossDomain: true,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": true,
  },
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    let belong = localStorage.getItem("belong")
    if (belong != null && belong != undefined && belong != '') {
      if (config.method == 'get') {
        if (config.url.indexOf('?') == -1) {
          config.url = config.url + '?belong=' + belong
        } else {
          config.url = config.url + '&belong=' + belong
        }
      } else {
        let data = JSON.parse(JSON.stringify(config.data))
        data.belong = JSON.parse(localStorage.getItem("belong"))
        config.data = data
      }
    }
    let token = localStorage.getItem('code')
    config.headers["loginname"] = store.tokenPhone ? store.tokenPhone : CacheModule.get("setToken");
    config.headers["token"] = token != undefined ? token : null;
    let user = localStorage.getItem('userInfo')
    if (user != undefined && user != null && user != '' && config.headers["token"] == null) {
      CacheModule.remove("loginPhone");
      CacheModule.remove("setToken");
      CacheModule.remove("qqOpenidType");
      CacheModule.remove("wxOpenidType");
      CacheModule.remove("uid");
      CacheModule.remove("userInfo");
      CacheModule.remove("code");
      sessionStorage.clear();
      mutations.getToken(false);
      stored.commit("Login/editIsUser", false);
      Dialog.alert({
        title: '提示',
        message: '新版本更新,请重新登录,',
      }).then(() => {
        router.push("index")
        location.reload()
      })
    }
    if (config.headers["token"] != null && config.headers["token"].length <= 11) {
      CacheModule.remove("loginPhone");
      CacheModule.remove("setToken");
      CacheModule.remove("qqOpenidType");
      CacheModule.remove("wxOpenidType");
      CacheModule.remove("uid");
      CacheModule.remove("userInfo");
      CacheModule.remove("code");
      sessionStorage.clear();
      mutations.getToken(false);
      stored.commit("Login/editIsUser", false);
      Dialog.alert({
        title: '提示',
        message: '新版本更新,请重新登录,',
      }).then(() => {
        router.push("index")
        location.reload()
      })
    }
    stored.commit('Login/showLoading')
    return config;
  },
  (error) => {
    stored.commit('Login/hideLoading')
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // router.push("index")
    stored.commit('Login/hideLoading')
    if (res.retuCode == 5000 || res.retuCode == 5021) {
      return Promise.resolve(res);
    } else if (res.retuCode == 5020) {
      CacheModule.remove("loginPhone");
      CacheModule.remove("setToken");
      CacheModule.remove("qqOpenidType");
      CacheModule.remove("wxOpenidType");
      CacheModule.remove("uid");
      CacheModule.remove("userInfo");
      CacheModule.remove("code");
      sessionStorage.clear();
      mutations.getToken(false);
      stored.commit("Login/editIsUser", false);
      Dialog.alert({
        title: '提示',
        message: '账号在别处登录,',
      }).then(() => {
        router.push("index")
        location.reload()
      })
    } else if (res.retuCode == 5004) {
      router.push("index")
    } else {
      return Promise.reject(res);
    }
  },
  (error) => {
    stored.commit('Login/hideLoading')
    return Promise.reject(error);
  }
);

export default service;
